import axios from 'axios'
import Repository from './Repository'
const resource = '/forgotPassword/forgot_password'

export default {
  forgotPassword(payload) {    
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  setNewPassword(token, payload) {    
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}/${token}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
}